import WhyChooseUs from "../component/WhyChooseUs";
import Produaly from "../component/Produaly";
import { motion, useAnimation } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-scroll";
import WorkDetail from "../component/WorkDetail";

const Work = () => {
  const [selectedWork, setSelectedWork] = useState(null);
  const workIcon = [
    {
      id: 1,
      icon: "/assets/chitra-project.svg",
      title: "Chitra Project",
      desc: "Chitra Coffee Bar is the perfect place to enjoy strong and tasty South Indian coffee in Vellore style.",
    },
    {
      id: 2,
      icon: "/assets/file-project.svg",
      title: "Folder Management System",
      desc: "The Folder Management System helps you organize and manage all your files and folders in one place.",
    },
    {
      id: 3,
      icon: "/assets/fivea-project.svg",
      title: "Fivea",
      desc: "The Fivea Project Franchise offers you the chance to bring our innovative products/services to your city.",
    },
    {
      id: 4,
      icon: "/assets/mobile-project.svg",
      title: "Ex-Servicemen",
      desc: "We aim to empower ex-servicemen with education, skill development, and employment opportunities.",
    },
    {
      id: 5,
      icon: "/assets/slide-project.svg",
      title: "SLIDE",
      desc: "The CRM project focuses on streamlining customer interactions and improving business efficiency.",
    },
    {
      id: 7,
      icon: "/assets/ennam-project.svg",
      title: "Ennam-Project",
      desc: "The platform includes order tracking, personalized recommendations, and a responsive design for all devices, ensuring a smooth and engaging user experience.",
    },
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 40, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  const controls = useAnimation();
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          controls.set("hidden");
          controls.start("visible");
        }
      },
      { threshold: 0.3 },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, [controls]);

  return (
    <>
      <Produaly />
      <motion.div
        ref={sectionRef}
        initial="hidden"
        animate={controls}
        className="px-4 sm:px-6 lg:px-20 mt-[20%] sm:mt-[10%] md:mt-[5%]"
      >
        <div className="relative rounded-[28px] sm:rounded-[36px] p-[3px]">
          <div
            className="rounded-[24px] sm:rounded-[32px]
  px-4 sm:px-10 md:px-14 lg:px-20
  py-8 sm:py-12 md:py-14
  bg-gradient-to-br
  from-[rgba(255,164,164,0.25)]
  to-[rgba(255,235,235,0.6)]
  border border-[#FFA4A4]

  shadow-[inset_0_2px_8px_rgba(0,0,0,0.12)] shadow-[#FFA4A4]"
          >
            <div className="flex justify-center">
              <div className="w-[140px] h-[36px] relative p-[2px] rounded-md animated-border">
                <h2
                  className="
        w-full h-full bg-white rounded-md text-[16px]
        font-semibold text-[#4D4C4C] font-clash tracking-wide
        flex items-center justify-center gap-3 
      "
                >
                  <span className="w-3 h-3 rounded-full bg-primary"></span>

                  <span>Portfolio</span>
                </h2>
              </div>
            </div>

            <>
              {selectedWork === null ? (
                // ===== GRID VIEW =====
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
                  {workIcon.map((wor, i) => (
                    <div
                      key={i}
                      className="cursor-pointer"
                      onClick={() => setSelectedWork(wor)}
                    >
                      <img src={wor.icon} alt="" />
                    </div>
                  ))}
                </div>
              ) : (
                <WorkDetail
                  selectedWork={selectedWork}
                  setSelectedWork={setSelectedWork}
                />
              )}
            </>
          </div>
        </div>
      </motion.div>

      <WhyChooseUs />
    </>
  );
};

export default Work;
